import React, { useEffect, useState } from "react";
import "../Zone/Zone.css";
import "../Overview/Overview.css";
import { fetchComplaintsPage } from "../../Services/locationEntries";

function fmtDate(ts) {
  if (!ts) return "—";
  const d = ts.toDate ? ts.toDate() : new Date(ts);
  return (
    d.toLocaleDateString("en-GB", { day: "2-digit", month: "short" }) +
    ", " +
    d.toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit", hour12: false })
  );
}

const STATUS_VARIANT = {
  OPEN: "bad",
  CLOSED: "ok",
  "UNDER REVIEW": "warn",
  "PENDING CLOSURE": "neutral",
};

const SOURCE_VARIANT = {
  public: "ok",
  customerSupport: "info",
  independentEngineer: "neutral",
};

const SOURCE_LABEL = {
  public: "Public",
  customerSupport: "CS",
  independentEngineer: "IE",
};

function LocationComplaints({ className, location, zone, ward, onBack, onComplaintClick }) {
  const [entries, setEntries] = useState(null);

  useEffect(() => {
    if (!location?.documentId) return;
    setEntries(null);
    fetchComplaintsPage({ locationId: location.documentId, pageSize: 10 })
      .then((page) => setEntries(page.items))
      .catch(() => setEntries([]));
  }, [location?.documentId]);

  return (
    <div className={className} data-cy="location-complaints-screen">
      <div className="subhdr">
        <div className="back" onClick={onBack}>
          <svg viewBox="0 0 24 24">
            <polyline points="15,18 9,12 15,6" />
          </svg>
        </div>
        <div className="subhdr-info">
          <div className="subhdr-crumb">
            Chennai › Zone {zone?.id} › Ward {ward?.id} › {location?.location || location?.PCTNo}
          </div>
          <div className="subhdr-title">Complaints</div>
        </div>
        {entries && (
          <span className="pill neutral">
            {entries.length}
          </span>
        )}
      </div>
      <div className="divider" />
      <div className="scroll">
        {entries === null && (
          <div style={{ padding: "24px 20px", fontSize: "var(--text-base)", color: "var(--t3)" }}>Loading…</div>
        )}
        {entries?.length === 0 && (
          <div style={{ padding: "24px 20px", fontSize: "var(--text-base)", color: "var(--t3)" }}>No complaints found.</div>
        )}
        {entries?.length > 0 && (
          <div className="lrows">
            {entries.map((c) => {
              const status = c.status?.currentStatus || "OPEN";
              const source = c.issuedBy?.type;
              return (
                <div key={c.documentId} className="lrow" onClick={() => onComplaintClick && onComplaintClick(c)}>
                  <div className="li">
                    <div className="ln">{c.category || "Complaint"}</div>
                    <div className="ls" style={{ fontFamily: "var(--font-mono)", letterSpacing: ".02em" }}>{c.documentId}</div>
                    <div className="ls">{fmtDate(c.createdAt)}</div>
                  </div>
                  <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-end", gap: "4px", flexShrink: 0 }}>
                    <span className={`snap-pill ${STATUS_VARIANT[status] || "neutral"}`}>{status}</span>
                    {source && (
                      <span className={`snap-pill ${SOURCE_VARIANT[source] || "neutral"}`}>
                        {SOURCE_LABEL[source] || source}
                      </span>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        )}
        <div style={{ height: "20px" }} />
      </div>
    </div>
  );
}

export default LocationComplaints;
